import React, { useState } from 'react';
import { Button, Col, Form, Row, Upload } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { UploadOutlined } from '@ant-design/icons';
import SVGIcon from '../../../../utils/SVGIcon';
import { Notification, dataToFormDataConverter } from '../../../../config/Global';
import { CONSTANT } from '../../../../config/Constant';
import { BtnBold, BtnItalic, Editor, EditorProvider, Toolbar } from 'react-simple-wysiwyg';

const defaultData = `<p>
שלום רב,<br />
אנו פונים אליכם על מנת שתעדכנו במערכותיכם<br />
את הניתוב החדש של מספר מקוצר עבור לקוח של חברת פייקול.<br />
להלן פרטי ההפניה המבוקשת:
</p>

<p><b>מספר הכוכבית:</b>	%asterisk_number%<br />
<b>הניתוב המבוקש:</b>	%shadow_number%</p>
<p>
לאישור שהניתוב בוצע, לחץ כאן<br />
%url%
</p>
<p>
מפעיל נכבד,<br />
חשוב לנו לוודא שקיבלת את ההודעה ולקבל את אישורך על ביצוע ההפנייה במייל חוזר.<br />
לשליחת המייל החוזר יש ללחוץ על הלחצן "אישור ביצוע ההפנייה" ולשלוח את ההודעה שתיפתח.
</p>`;

const SendAsteriskForm: React.FC<any> = ({ getList }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [msgValue, setMsgValue] = useState(defaultData);

  const authToken = localStorage.getItem('token');

  var myHeaders = new Headers();
  myHeaders.append('Authorization', authToken ? authToken : '');

  const handleSubmit = async (data?: any) => {
    setLoading(true);
    data.text_body = msgValue;

    const formData = dataToFormDataConverter(data);
    if (fileList.length > 0) {
      formData.append('pdf_file', fileList[0]?.originFileObj);
    }

    try {
      const response = await fetch(`${CONSTANT.BASE_URL}/asterisk/add`, {
        method: 'POST',
        body: formData,
        headers: myHeaders,
      });

      if (response.ok) {
        setLoading(false);
        // console.log('File uploaded successfully!');
        Notification.success({
          message: 'File uploaded successfully.',
        });
      } else {
        setLoading(false);
        // console.log('File upload failed......');
        Notification.success({
          message: 'Asterisk send failed',
        });
      }
      form.resetFields();
      getList();
    } catch (error) {
      setLoading(false);
      // console.log('File upload failed.');
      console.error('Error uploading file:', error);
      Notification.error({
        message: 'File upload failed.',
      });
    }
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  //   const beforeUpload = (file: any) => {
  //     const isPDF = file.type === 'application/pdf';
  //     if (!isPDF) {
  //       message.error(`${file.name} is not a pdf file`);
  //     }
  //     return isPDF || Upload.LIST_IGNORE;
  //   };

  // const beforeUpload = (file: any) => {
  //   const isPDF = file.type === 'application/pdf';
  //   if (!isPDF) {
  //     message.error(`${file.name} is not a pdf file`);
  //     return Upload.LIST_IGNORE;
  //   }
  //   const isLt2MB = file.size / 1024 / 1024 <= 2;
  //   if (!isLt2MB) {
  //     message.error(`${file.name} is larger than 2MB`);
  //     return Upload.LIST_IGNORE;
  //   }
  //   return isPDF && isLt2MB;
  // };

  const handleFileChange = ({ fileList }: any) => {
    setFileList(fileList);
    form.setFieldsValue({ upload_pdf: fileList.length ? fileList : null });
  };

  //   const onRemoveFile = (info: any, index: number) => {
  //     console.log('onRemove info = ' + info);
  //     const newForm = form;
  //     newForm.inputs[index].value = null;
  //     setForm({
  //       ...form,
  //       from: newForm,
  //     });
  //     console.log('onRemove form = ' + form);
  //   };

  function onChange(e) {
    setMsgValue(e.target.value);
  }

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={['onBlur', 'onInput']}
        autoComplete="off"
        initialValues={{
          text_body:
            'Hello, Please find Asterisk Number details: Asterisk Number = %asterisk_number% and Shadow Number = %shadow_number%. Thank you.',
        }}
      >
        <Row
          gutter={[20, 0]}
          align={'top'}
        >
          <Col
            xs={24}
            md={12}
            lg={8}
            xl={6}
          >
            <InputBox.Text
              label="Asterisk Number"
              name={'asterisk_number'}
              tooltip="A single number to request to be ported.
              Must be in a domestic form (e.g. 12223555 or *3555)"
              required
              rules={[
                validations.required.text('Asterisk Number'),
                validations.pattern.numericWithSecial,
                // validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
            lg={8}
            xl={6}
          >
            <InputBox.Text
              label="Shadow Number"
              name={'shadow_number'}
              tooltip="A single number to request to be ported.
                    Must be in a domestic form (e.g. 12223555 or *3555)"
              required
              rules={[
                validations.required.text('Shadow Number'),
                validations.pattern.numericWithSecial,
                // validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
            lg={8}
            xl={6}
          >
            <InputBox.Text
              label="Name"
              name={'name'}
              rules={[validations.required.text('Name'), validations.pattern.whitespace]}
            />
          </Col>
          <Col
            xs={24}
            md={12}
            lg={6}
            xl={6}
          >
            <Form.Item
              name="upload_pdf"
              label="Upload PDF"
              rules={[{ required: true, message: 'Please upload a PDF file' }]}
            >
              <Upload
                // beforeUpload={beforeUpload}
                beforeUpload={() => false}
                maxCount={1}
                // onRemove={onRemoveFile}
                // fileList={fileList}
                onChange={handleFileChange}
                accept="application/pdf"
                listType="text"
              >
                <Button icon={<UploadOutlined />}>Upload PDF</Button>
                {/* {fileList?.length > 0
                  ? fileList?.map((item: any) => {
                      return <div className="mt-10">{item.name}</div>;
                    })
                  : null} */}
              </Upload>
            </Form.Item>
          </Col>
          <Col xs={24}>
            <EditorProvider>
              <Editor
                containerProps={{ style: { resize: 'vertical' } }}
                value={msgValue}
                onChange={onChange}
                // dir="rtl"
              >
                <Toolbar>
                  <BtnBold />
                  <BtnItalic />
                </Toolbar>
              </Editor>
              <p>
                <span className="text-red">Note:</span> %asterisk_number% means Asterisk Number / %shadow_number% means
                Shadow Number / %url% means URL for confirmation.
              </p>
            </EditorProvider>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={4}
          >
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              <SVGIcon
                icon="add"
                color="#fff"
                width={55}
              />
              Add{' '}
            </Button>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={4}
          >
            <Button
              type="default"
              htmlType="reset"
              onClick={() => {
                setFileList([]);
                form.resetFields();
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default SendAsteriskForm;
